import { Section, useHasPermission, useIsAddonEnabled } from "@dgs/core";
import styled from "styled-components";
import { Addon } from "../../../shared/types/addon";
import { PermissionName } from "../../../shared/types/permission";
import { BirthdaysWidget } from "../dashboard/widgets/birthdays/BirthdaysWidget";
import { EventsWidget } from "../dashboard/widgets/events/EventsWidget";
import { TestDrivesWidget } from "../dashboard/widgets/testDrives/TestDrivesWidget";

export const StyledSection = styled(Section)`
	padding-top: ${({ theme }) => theme.spacing(5)};
	padding-bottom: ${({ theme }) => theme.spacing(5)};
	display: grid;
	align-items: stretch;
	grid-template-columns: 1fr;

	${({ theme }) => theme.breakpoints.desktop} {
		grid-template-columns: 1fr 1fr;
	}

	gap: ${({ theme }) => theme.spacing(10)};
`;

export const DashboardPage = () => {
	const canReadEvents = useHasPermission<PermissionName>(["event.read"]);
	const canReadContacts = useHasPermission<PermissionName>(["contact.read"]);
	const canReadApplications = useHasPermission<PermissionName>(["application.read"]);
	const canReadOwnApplications = useHasPermission<PermissionName>(["application.readOwn"]);
	const isContactDatabaseEnabled = useIsAddonEnabled(Addon.CONTACT_DATABASE);

	return (
		<StyledSection>
			{canReadEvents && <EventsWidget />}
			{canReadContacts && isContactDatabaseEnabled && <BirthdaysWidget />}
			{(canReadApplications || canReadOwnApplications) && isContactDatabaseEnabled && <TestDrivesWidget />}
		</StyledSection>
	);
};
